import { render, staticRenderFns } from "./SowedStage.vue?vue&type=template&id=32821732&scoped=true"
import script from "./SowedStage.vue?vue&type=script&lang=js"
export * from "./SowedStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32821732",
  null
  
)

export default component.exports